import { render, staticRenderFns } from "./LoginRoute.vue?vue&type=template&id=85ebb366&scoped=true&"
import script from "./LoginRoute.vue?vue&type=script&lang=js&"
export * from "./LoginRoute.vue?vue&type=script&lang=js&"
import style0 from "./LoginRoute.vue?vue&type=style&index=0&id=85ebb366&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ebb366",
  null
  
)

export default component.exports